<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    version: 'success' | 'error' | 'warn' | 'info';
  }>(),
  {
    version: 'info',
  },
);
</script>

<template>
  <div :class="`message ${props.version}`">
    <slot/>
  </div>
</template>

<style scoped lang="postcss">
.message {
  padding: 1rem;
  border-radius: 0.375rem;
}

.success {
  background-color: var(--color-emerald-100);
  border: 1px solid var(--color-emerald-50);
  color: var(--color-emerald-600);
}

.error {
  background-color: var(--color-rose-100);
  border: 1px solid var(--color-rose-50);
  color: var(--color-rose-600);
}

.info {
  background-color: var(--color-indigo-100);
  border: 1px solid var(--color-indigo-50);
  color: var(--color-indigo-600);
}

.warn {
  background-color: var(--color-orange-100);
  border: 1px solid var(--color-orange-50);
  color: var(--color-orange-600);
}
</style>
